import React, {useState, useEffect} from 'react';
import Spinner from 'components/Spinner/Spinner';
import {openModal} from 'state/modals/actions';
import {trackClick} from 'utility/analytics';
import { Button } from 'theme/Button';
import {HelmetWrapper, basicHelmetGenerator} from 'utility/DefaultMeta';
import history from 'historyContainer';
import CustomBreadcrumbs from 'utility/CustomBreadcrumbs';
import {uniq, get, find, filter, map} from 'lodash';
import { NavLink, Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { XL, XXL, MD, LG } from '@zendeskgarden/react-typography';
import { Col, Row } from '@zendeskgarden/react-grid';
import {SERVICES, linkArray} from './categoriesData.js'
import { GET_LISTINGS } from 'state/listings/gql';
import { useQuery } from '@apollo/client';
import ProductItemGrid from 'components/ProductItemGrid/ProductItemGrid';
import { variables } from 'theme/variables';

import { 
  ItemCol, 
  ItemRow,
  NavItem,
  NavList
} from './CategoriesOffered.styles.js';

const {
  custom_blue,
} = variables;


export const Image = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 0px;  
  background-color: rgb(255, 255, 255);
  height: 200px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`

export const StyledHeader = styled.div`
  margin-bottom: 40px;
`


const CategoriesOffered = (props) => {
  const tag = props.match.params.catGroupSlug;
  const slug = props.match.params.catSlug;

  let servicesOffered = !tag ? SERVICES : filter(SERVICES, (s) => {
    return s.type === tag
  });

  const allServices = servicesOffered;

  let activeService = find(SERVICES, (s) => {
    return s.type === tag
  });


  if (slug && activeService) {
    activeService = find(activeService.services, (s) => {
      return s.slug === slug
    })
  }

  if (slug && get(servicesOffered, '[0].services')) {
    servicesOffered = filter(servicesOffered[0].services, (s) => {
      return s.slug === slug
    });
  }

  let equipmentType;
  if(activeService) {
    equipmentType  = activeService.title
  }

  
  const listings = useQuery(GET_LISTINGS);
  
  const [relatedListingsArray, setRelatedListings] = useState(filterListings(get(listings, 'data.Listings'),servicesOffered));
  const [brands, setRelatedListingsBrands] = useState([]);
  const [brandFilter, setBrandFilter] = useState('All');
  const [relatedListingsFiltered, setRelatedListingsFiltered] = useState();

  const relatedListings = relatedListingsFiltered || relatedListingsArray;


  useEffect(() => {
    const result = filter(relatedListingsArray, (s) => {
      return s.listing_brand === brandFilter || brandFilter === 'All'
    });
    setRelatedListingsFiltered(result)
  }, [brandFilter, relatedListingsArray])


  useEffect(() => {
    setBrandFilter('All')
  }, [tag, slug])


  function goTorequest() {
    trackClick('inquireForm', 'Submit A Request', 'LandingHero');
    openModal({
      type: 'inquireFormModal',
    })  
  }



  useEffect(() => {
    const data = filterListings(get(listings, 'data.Listings'), servicesOffered)
    const brands = uniq(map(data, d => d.listing_brand));
    setRelatedListings(data);
    setRelatedListingsBrands(brands);

  }, [get(listings, 'data.Listings.length'), tag, slug]);

  function filterListings(data, servs) {
    return filter(data, l => {
      const f = slug ? servs && servs[0] && servs[0].models && servs[0].models.indexOf(l.listing_model) > -1 : tag && activeService ? activeService.type.replace('-', '/').toUpperCase() === l.listing_style : true;
      return f
    });
  }



  return (
    <div>
      {
        activeService ?
        <HelmetWrapper metadata={basicHelmetGenerator({
          title:`MRI Technologies - ${activeService ? `Quality Reconditioned ${equipmentType} For Sale` : `Whether MRI, CT or PET we take pride in the most dependable medical imaging equipment for sale in the market.`}`,
          description: activeService.description,
        })} /> : null
      }
      


      <div style={{marginBottom: '20px'}}>
        <CustomBreadcrumbs disableDefaults={false} removeRoot={true} omit={['/c']} />
      </div>


      <StyledHeader>
        {/*<MD bold letterSpacing="true" slate uppercase tag="p">MRT EQUIPEMNT: {activeService ? (activeService.slug || activeService.type) : 'CT, MRI, PET, ULTRASOUND'}</MD>*/}
        {
          !equipmentType ?
          <XXL as="h1" bold  paddingTopSm>
            The Best Engineers Provide The Best Equipment
          </XXL> :
          <XXL style={{maxWidth: '1000px'}} as="h1" bold  paddingTopSm>
            Quality Reconditioned {activeService ? equipmentType : 'Medical Equipment'} For Sale
          </XXL>
        }
        

        <MD style={{maxWidth: '1000px'}} light  paddingTopMd>
        </MD>

        <LG style={{maxWidth: '1000px'}} as="h3" light navy paddingTopSm paddingBottomXl>
          {
            activeService ? activeService.description :
            `Whether MRI, CT or PET we take pride in the most dependable medical imaging equipment and services in the market. Your machine will look and perform like new, be up to OEM specifications and operate cleanly for your patients’ needs.`
          }
        </LG>
        {
          true ?
          <div>
            <NavList>
              {
                map(slug ? (allServices[0] && allServices[0].services) : linkArray, (link, i) => {
                  link = link.slug ? {title: link.title || link.name, link: `/c/equipment/${allServices[0].type}/${link.slug}`} : link
                  return (
                    <NavItem key={i}>
                      <NavLink exact activeClassName="active-content-link" to={link.link}>
                        {link.title}
                      </NavLink>
                    </NavItem>
                  )
                })
              }
            </NavList>
          </div> : null
        }
      </StyledHeader>

      {
        !slug ?
        <ItemRow activeService={activeService}>
          <ItemCol size="12">
            {
              map(slug ? allServices : servicesOffered, (sc, i) => {
                return (
                  <ItemRow activeService={activeService} key={`${i}-${sc.title}`} style={{marginTop: 0, marginBottom: '60px'}}>

                    <ItemCol size="12">
                      {!activeService ?<XL bold as="h2" paddingBottomSm>{sc.title}</XL> : null}
                      {!activeService ?<MD as="h3" style={{maxWidth: '1000px', marginBottom: '70px'}} slate>{sc.description}</MD> : null}
                      <ItemRow activeService={activeService} key={i}>
                        {
                          map(sc.services, (s, n) => {
                            return (
                              <ItemCol key={s.title} style={{cursor: 'pointer'}} onClick={() => history.push(`/c/equipment/${s.type}/${s.slug}`)}  size="12" md={4} extraPaddingRight>
                                <div>
                                  <div>
                                    <Image style={{backgroundImage: `url(${s.image || "https://www.mritechnologies.com/images/index-cover-rf.jpg"})`}}/>
                                  </div>
                                  <Link onClick={(e) => e.stopPropagation()} to={`/c/equipment/${s.type}/${s.slug}`}><MD style={{display: 'block'}} link uppercase paddingTopMd semibold tag="span">{s.title}</MD></Link>
                                  <MD paddingBottomMd paddingTopMd slate light tag="h3" as="h3">
                                    {s.description}
                                  </MD>
                                </div>
                              </ItemCol>

                            )
                          })
                        }
                      </ItemRow>
                      
                    </ItemCol>
                  </ItemRow>

                )
              })
            }
          </ItemCol>
        </ItemRow> : null
      }


      {
        equipmentType && get(relatedListings, 'length') ?
        <ItemRow>
          <ItemCol>
            <Row style={{marginBottom: '5px'}}>
              <Col size={12} md={6}>
                <LG as="h2" tag="h2" style={{fontSize: '26px', marginBottom: '15px', display: 'flex'}} scaled bold>{equipmentType} Machines <span style={{paddingLeft: '15px', fontWeight: '400', fontSize: '20px'}}>({get(relatedListings, 'length', 0)})</span></LG>
              </Col>
              <Col size={'auto'} md={6} justifyEnd>
                <NavList>
                {
                  map(['All', ...brands], (b, i) => {
                    const active = b === brandFilter;
                    return (
                      <NavItem key={b}><MD onClick={() => setBrandFilter(b)} style={{marginBottom: '10px', borderBottom: active ? `2px solid ${custom_blue}` : '1px solid transparent', textDecoration: 'none', color: active ? custom_blue : 'rgba(0,0,0,0.4)'}} hover semibold link={false} slate>{b}</MD></NavItem>
                    )
                  })
                }
                </NavList>
              </Col>
            </Row>

            <ProductItemGrid items={relatedListings}/>
          </ItemCol>
        </ItemRow> : 
        get(listings, 'loading') ? 
        <div>
          <Spinner />
        </div> :
        get(relatedListings, 'length') === 0 && slug && tag && activeService &&  equipmentType && !get(relatedListings, 'length') ?
        <div>
          <LG>No Machines Currently In Stock Matching Request.</LG>
          <Button primaryOutline spacingTopSm onClick={() => history.push('/c/equipment')}>See All Equipment</Button>
          <Button primary style={{marginLeft: '10px'}} spacingTopSm onClick={() => goTorequest()}>Get in Contact</Button>
        </div> : null
      }
      </div>
  )
}


export default CategoriesOffered;
